import React, { Component } from "react";
import Link from 'next/link'
import { route } from 'themes/route'
import Layout from 'themes/layouts/Home'
import { DatePicker, message } from 'antd';
import { Button, Row, Col, Typography, Carousel } from 'antd';
const { Title } = Typography
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};
import useBaseHook from 'themes/hooks/BaseHooks'

const DetailBlog = () => {
  const { t } = useBaseHook()
  return <Layout>
    <div id="bannerHeaderHome">
      <div className="container">
        <Row>
          <Col lg={12} xl={12}>
            <div className="contentTextInfoHeader">
              <h3><span className="lineTop"></span>{t("home.quote")}</h3>
              <h1>{t("home.blog.title")}g</h1>
              <h2>{t("home.blog.subTitle")}</h2>
              <Button className="resAccountMqn">{t("home.index.createAccount")}</Button>
              <Button className="contactSale">{t("home.index.contactSale")}</Button>
            </div>
          </Col>
          <Col lg={12} xl={12}>
            <div className="imgHeader">
              <img src="/static/img/about-img1.png" alt="dohu.vn" />
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <div id="detailLocation">
      <div className="container">
        <Row>
          <div className="imgAvataLocation">
            <img src="/static/img/imgblog1.png" alt="dohu.vn" />
          </div>
          <div className="infoMainContent">
            <h6><span className="lineTop"></span> Best Practices</h6>
            <h1>{t("home.blog.cardTitle")}</h1>
            <h2>{t("home.blog.cardDate")}</h2>
            <p>{t("home.blog.cardContent")}</p>
            <h3>Why chose the beauty and grooming environment?</h3>
            <div className="contentItemServie">
              <div className="itemServieDetail">
                <Row>
                  <Col span={2}>
                    <img src="/static/img/no1.svg" alt="dohu.vn" />
                  </Col>
                  <Col span={22}>
                    <h1>{t("home.blog.diverseAudience")}</h1>
                    <p>{t("home.blog.diverseAudienceContent")}</p>
                  </Col>
                </Row>
              </div>
              <div className="itemServieDetail">
                <Row>
                  <Col span={2}>
                    <img src="/static/img/no2.svg" alt="dohu.vn" />
                  </Col>
                  <Col span={22}>
                    <h1>{t("home.blog.targetedAudience")}</h1>
                    <p>{t("home.blog.targetedAudienceContent")}</p>
                  </Col>
                </Row>
              </div>
              <div className="itemServieDetail">
                <Row>
                  <Col span={2}>
                    <img src="/static/img/no3.svg" alt="dohu.vn" />
                  </Col>
                  <Col span={20}>
                    <h1>{t("home.blog.captiveAudience")}</h1>
                    <p>{t("home.blog.captiveAudienceContent")}</p>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Row>
      </div>
    </div>

  </Layout>
}
export default DetailBlog